/**
 * @description 错题/收藏小节列表
 */

import Api from '../../../../path';
import {fetchData} from '@umu/umu-fetch';

export interface IQuestionCollectionInfo {
    course_id: string;
    element_id: string;
    is_deleted: number; // 是否被删除，1删除，0未删除
    course_title: string;
    element_title: string;
    course_share_url: string;
    element_share_url: string;
    knowledge_point_id: string;
    knowledge_point_name: string;
    last_add_time: number;
    update_time: number;
    practice_type: number;
    question_num: number;
    element_type?: number;
    session_type?: number;
}

export interface IInput {
    practice_type: number; // int，1 易错题，2 已收藏
    page: number; // int，必填，分页页码
    size: number; // int，必填，每页展示数据量
    data_type?: number; // int，0 按小节/活动查看 1 按知识点查看
}

export const getQuestionElementList = (data: IInput): Promise<IList<IQuestionCollectionInfo>> => {
    return fetchData(Api.QUESTION_COLLECTION_GET_ELEMENT_LIST, data).then(
        (res: IListResponse<IQuestionCollectionInfo>) => {
            return res.data;
        },
    );
};
